import axios from "axios";
import Vue from "vue";
import router from "../router";
import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import store from "../store/store";

export default class FastApiAuthService {
  refresh;

  constructor() {
    // Get realm from query string or local storage
    //this.setAuth();
    // Clear local storage if previous session used different auth provider
    const storedAuthProvider = localStorage.getItem("auth_provider");
    if (storedAuthProvider && storedAuthProvider !== "fastapi") {
      localStorage.removeItem("auth_provider");
      this.removeTokensFromLocalStorage();
    }

    // Throw alert if environment file is missing required variables
    if (!process.env.VUE_APP_FASTAPI_CONFIG) {
      alert("Missing environment variables for MyndAuth");
    }
  }

  setAuth(){
    if(!localStorage.getItem("jwt")){
      router.push("/login").catch(()=>{});
    }
    else{
      return axios
        .post('/podstatus?user='+localStorage.getItem("jwt"), {
          //headers
        })
        .then(response => {
          console.log(response.data);
          if (response.data.token_status === "INVALID") {
            console.error(`Token status: ${response.data.token_status}`);
            this.removeTokensFromLocalStorage();
            window.location.reload();
            return;
          }
          if (response.data.token_status === "VALID" && response.data.user_container_status === "Terminating") {
            setTimeout(() => {
              console.error(`Container status: ${response.data.user_container_status}`);
              this.removeTokensFromLocalStorage();
              window.location.reload();
              return;
            }, 30000)
          }
          

          Vue.prototype.$globalSettings = {
            ...response.data,
            auth_provider: "fastapi",
            auth_endpoint: response.data["auth-server-url"],
            api_endpoint:
              process.env.VUE_APP_FASTAPI_API + response.data.api_endpoint
          };
          store.dispatch('saveAuthenticatedUserInfo', response.data);
          if(store.state.auth.passStatus === 'yes'){
            router.push("/projects").catch(()=>{});
          }
          else{
            router.push({'name': "UpdatePassword"}).catch(()=>{});
          }
        })
        .catch(() => {
          console.log("Error fetching settings");
          this.redirectToLogin();
        });
        //router.push("/projects").catch(()=>{});
      }
  }

  redirectToLogin() {
    router.push("/login").catch(()=>{});
  }

  async init() {
    Vue.prototype.$authService = this;
    if(!localStorage.getItem("jwt")){
      router.push("/login").catch(()=>{});
    }
    else{
      return axios
        .post('/podstatus?user='+localStorage.getItem("jwt"), {
          //headers
        })
        .then(response => {
          if (response.data.token_status === "INVALID") {
            console.error(`Token status: ${response.data.token_status}`);
            this.removeTokensFromLocalStorage();
            window.location.reload();
            return;
          }
          if (response.data.token_status === "VALID" && response.data.user_container_status === "Terminating") {
            setTimeout(() => {
              console.error(`Container status: ${response.data.user_container_status}`);
              axios.get('/auth/updatelogin?user='+localStorage.getItem("jwt"))
              .then(() => {
                this.removeTokensFromLocalStorage();
                store.dispatch('logOut');
                clearInterval(this.refresh);
                this.redirectToLogin();
              })
              return;
            }, 30000)
          }

          Vue.prototype.$globalSettings = {
            ...response.data,
            auth_provider: "fastapi",
            auth_endpoint: response.data["auth-server-url"],
            api_endpoint:
              process.env.VUE_APP_FASTAPI_API + response.data.api_endpoint
          };
          store.dispatch('saveAuthenticatedUserInfo', response.data);
          //if(store.state.auth.passStatus === 'yes'){
          //  console.log("Password is good");
          router.push("/projects").catch(()=>{});
          //}
          //else{
          //  router.push({'name': "UpdatePassword"}).catch(()=>{});
          //}
          this.initTokenRefresh();
        })
        .catch(() => {
          console.log("Error fetching settings");
          axios.get('/auth/updateloginifexp?user='+localStorage.getItem("username"))
            .then(() => {
                this.removeTokensFromLocalStorage();
                store.dispatch('logOut');
                clearInterval(this.refresh);
            })
            .catch(() => {
              console.log("Error updating login");
              this.removeTokensFromLocalStorage();
              store.dispatch('logOut');
              clearInterval(this.refresh);
              this.redirectToLogin();
            });
        });
        //router.push("/projects").catch(()=>{});
      }
  }

  async logout() {
    ApiRequest.exploreGet("logout", GetHeaders.dataHeaders())
    this.removeTokensFromLocalStorage();
    store.dispatch('logOut');
    clearInterval(this.refresh);
    this.redirectToLogin();
  }

  initTokenRefresh() {
    // Start timer to try refresh token every minute
    this.refresh = setInterval(() => {
        ApiRequest.explorePost("refresh", {token : localStorage.getItem("jwt")}, GetHeaders.projectHeaders())
          .then((response) => {
          localStorage.setItem('jwt', response.data.user.token);
          store.dispatch('updateAuthenticatedUserInfo');
        })
        .catch((error) => {
          console.log(error);
          console.error("Token refresh error");
          //this.logout();
        });
    }, 30 * 1000);
  }

  mappedUserInfo() {
    return {
      id: this.keycloak.tokenParsed.sub,
      role: "user",
      name: this.keycloak.tokenParsed.preferred_username,
      fullname: this.keycloak.tokenParsed.name
    };
  }

  authenticated() {
    if (!localStorage.getItem("jwt")) {
      return false;
    }
    else{
      return true;
    }
  }

  tokenStillValid() {
    if (!localStorage.getItem("jwt")) {
      return false;
    }
    else{
      return true;
    }
  }

  removeTokensFromLocalStorage() {
    localStorage.removeItem("jwt");
    localStorage.removeItem("username");
    localStorage.removeItem("userRole");
    localStorage.removeItem("auth_provider");
    localStorage.removeItem("passupdated");
  }
}
